<template>
  <div>
    <b-modal
      id="add-notes-article-item"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('addNotes')}: ${articleNumber}, ${$t('State')}: ${stateLabel}`"
      hide-footer
      size="md"
      @close="onCancel"
    >
      <b-form-group
        :label="$t('Description')"
      >
        <b-form-textarea
          v-model="notes"
          :placeholder="$t('Notes..')"
        />
      </b-form-group>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  props: ['orderNumber', 'orderItemId', 'articleNumber', 'state'],
  data() {
    return {
      notes: null,
      allStates: [
        { label: this.$t('Assigned'), value: 1 },
        { label: this.$t('Confirmed'), value: 2 },
        { label: this.$t('InPattern'), value: 3 },
        { label: this.$t('InPatternQualityPassed'), value: 4 },
        { label: this.$t('InPatternQualityNotPassed'), value: 5 },
        { label: this.$t('InPatternCompleted'), value: 6 },
        { label: this.$t('InSewingAssigned'), value: 7 },
        { label: this.$t('InSewingConfirmed'), value: 8 },
        { label: this.$t('InSewing'), value: 9 },
        { label: this.$t('InSewingQualityPassed'), value: 10 },
        { label: this.$t('InSewingQualityNotPassed'), value: 11 },
        { label: this.$t('InSewingCompleted'), value: 12 },
        { label: this.$t('InHandSewingAssigned'), value: 13 },
        { label: this.$t('InHandSewingConfirmed'), value: 14 },
        { label: this.$t('InHandSewing'), value: 15 },
        { label: this.$t('InHandSewingQualityPassed'), value: 16 },
        { label: this.$t('InHandSewingQualityNotPassed'), value: 17 },
        { label: this.$t('InHandSewingCompleted'), value: 18 },
        { label: this.$t('OnHold'), value: 29 },
      ],
    }
  },
  computed: {
    stateLabel() {
      const stateObj = this.allStates.find((item) => { return item.value === this.state });
      return stateObj ? stateObj.label : this.$t('Unknown');
    },
  },
  methods: {
    onSubmit() {
      const objekti = {
        notes: this.notes,
        orderItemId: this.orderItemId,
      }
      this.$emit('addNotes', objekti)
      this.$refs.modal.hide()
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
      this.resetForm()
    },
    onCancel() {
      this.$refs.modal.hide()
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
      this.resetForm()
    },
    resetForm() {
      this.notes = null
    },
  },
}
</script>
